export default __webpack_public_path__ + "static/media/330_business03-jp-web.6dcaf64f.png";